import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from "@angular/core";
import { TractorViewModel, TractorStatus } from "@app/shared/models/tractors/TractorViewModel.model";
import { DriverService } from "@app/driver/shared/driver.service";

@Component({
  selector: "app-tractor-profile",
  templateUrl: "./tractor-profile.component.html",
  styleUrls: ["./tractor-profile.component.css"],
})
export class TractorProfileComponent implements OnInit, OnChanges {
  @Input() tractor: TractorViewModel;
  @Input() isEditMode: boolean;
  @Input() terminals: Array<string>;
  @Input() states: { abbreviation: string; fullName: string }[];
  @Input() dateInputMask: any;
  @Input() peoplenetStatus: string = "";
  @Input() isLoadingPeoplenetStatus: boolean = false;

  @Output() hasChanges = new EventEmitter<boolean>();
  @Output() driverChanged = new EventEmitter<void>();

  drivers: any[] = [];
  private originalTractor: string;
  tractorStatuses = TractorStatus;
  tractorStatusOptions = [
    { value: TractorStatus.Available, label: "Available" },
    { value: TractorStatus.Shop, label: "Shop" },
    { value: TractorStatus.OOS, label: "OOS" }
  ];

  constructor(private driverService: DriverService) {}

  ngOnInit() {
    this.originalTractor = JSON.stringify(this.tractor);
    this.loadDrivers();
  }

  loadDrivers() {
    this.driverService.listSelectFormat(true, false).subscribe(
      (drivers: any) => {
        this.drivers = drivers;
      },
      (error) => {
        console.error("Error loading drivers:", error);
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["tractor"] && !changes["tractor"].firstChange) {
      this.originalTractor = JSON.stringify(this.tractor);
      this.checkForChanges();
    }
  }

  onFieldChange() {
    this.checkForChanges();
  }

  onDriverChange() {
    // Update the driver object when driverId changes
    if (this.tractor.driverId) {
      const selectedDriver = this.drivers.find(d => d.id === this.tractor.driverId);
      if (selectedDriver) {
        this.tractor.driver = selectedDriver;
      }
    } else {
      this.tractor.driver = null;
    }
    // Notify parent that driver changed so it can reload Peoplenet status
    this.driverChanged.emit();
    this.onFieldChange();
  }

  private checkForChanges() {
    const currentTractor = JSON.stringify(this.tractor);
    const changed = currentTractor !== this.originalTractor;
    this.hasChanges.emit(changed);
  }

  getPeopleNetStatus(): string {
    if (this.isLoadingPeoplenetStatus) {
      return "LOADING...";
    }
    return this.peoplenetStatus || "NO STATUS AVAILABLE";
  }

  getTractorStatusLabel(): string {
    if (this.tractor?.status === undefined || this.tractor?.status === null) {
      return "Available";
    }
    const status = this.tractorStatusOptions.find(opt => opt.value === this.tractor.status);
    return status ? status.label : "Available";
  }

  getAssignedDriverName(): string {
    if (this.tractor?.driver) {
      const name = this.tractor.driver.name || this.tractor.driver.Name || "";
      const lastName = this.tractor.driver.lastName || this.tractor.driver.LastName || "";
      return `${name} ${lastName}`.trim();
    }
    return "";
  }
}

